import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import MaskedInput from 'react-text-mask';
import {
  saveAppUser,
  getAppUser,
  getJobTitles,
} from '../../../redux/appUsers/appUserActions';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Collapse,
  Avatar,
  Typography,
  Grid,
  Button,
  FormControl,
  List,
  TextField,
  ListItem,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  avatar: {
    padding: 10,
    backgroundColor: 'black',
  },
  expand: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
  },
  expandOpen: {
    display: 'none',
  },
  avatar: {
    backgroundColor: '#42ADE2',
  },
  inputMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      '&:hover': {
        borderColor: theme.palette.secondary.main,
      },
    },
    [theme.breakpoints.up('md')]: {
      '&:hover': {
        borderColor: theme.palette.secondary.main,
      },
    },
  },
  btnMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(2),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
  },
}));

const TextMaskCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '1',
        '-',
        /[1-9]/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      placeholder='1-555-555-5555'
    />
  );
};

const ProfilePage = () => {
  document.title = 'Sciata Profile';

  const classes = useStyles();
  const user = useSelector(state => state.users.currentUser);
  const appUser = useSelector(state => state.appUsers.selectedUser);
  const dispatch = useDispatch();
  const jobTitles = useSelector(state => state.appUsers.jobTitles);

  const [expanded, setExpanded] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [mobile, setMobile] = useState('');

  useEffect(() => {
    dispatch(getAppUser(user.id));
  }, [updated]);

  useEffect(() => {
    dispatch(getJobTitles());
  }, []);

  const getJobTitleName = id => {
    if (appUser && appUser.jobTitleId) {
      let job = jobTitles.find(jobTitle => {
        return jobTitle.id === id;
      });
      if (job) {
        return job.jobTitle;
      }
    }
    console.log('NO JOB TITLE FOUND');
    return null;
  };

  const handleExpandClick = () => setExpanded(!expanded);
  const handleCancel = () => {
    setMobile('');
    setExpanded(!expanded);
  };

  const handleSave = async () => {
    await dispatch(saveAppUser({ ...user, mobile: mobile }, user.id));
    setUpdated(!updated);
    dispatch(getAppUser(user.id));
  };

  // console.log('APP USER', appUser);

  return (
    <>
      <h1>Profile</h1>
      <Card className={classes.root}>
        {!Object.keys(appUser).length ? (
          <div>Loading...</div>
        ) : (
          <>
            <Grid container justify='center' alignItems='center'>
              <Grid item xs={12} md={4} container>
                <Avatar aria-label='recipe' className={classes.avatar}>
                  {appUser.firstName.slice(0, 1)}
                </Avatar>
              </Grid>
              <Grid item xs={12} md={4}>
                <CardHeader
                  action={null}
                  title={`${appUser.firstName} ${appUser.lastName}`}
                  subheader={`${appUser.emailId}`}
                />
              </Grid>
              <Grid item xs={12} md={4} />
            </Grid>
            <CardContent>
              <Grid container justify='center' alignItems='center' spacing={5}>
                <Grid item md={4} xs={12}>
                  <Typography variant='subtitle2' color='textSecondary'>
                    Phone
                  </Typography>
                  <Typography variant='h6'>{appUser.mobile || 'N/A'}</Typography>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Typography variant='subtitle2' color='textSecondary'>
                    Role
                  </Typography>
                  <Typography variant='h6'>
                    {(appUser.role && appUser.role) || 'N/A'}
                  </Typography>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Typography variant='subtitle2' color='textSecondary'>
                    Job Title
                  </Typography>
                  <Typography variant='h6'>
                    {getJobTitleName(appUser.jobTitleId) || 'N/A'}
                  </Typography>
                </Grid>
                <Grid
                  xs={12}
                  item
                  direction='column'
                  container
                  justify='center'
                  alignItems='center'
                >
                  <Typography variant='subtitle2' color='textSecondary'>
                    Projects
                  </Typography>
                  <List className={classes.listRoot}>
                    {appUser.projects.length
                      ? appUser.projects.map(project => (
                          <ListItem>
                            <Typography variant='h6'>{project.name}</Typography>
                          </ListItem>
                        ))
                      : 'N/A'}
                  </List>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions
              disableSpacing
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label='show more'
              >
                Edit Contact Info
              </Button>
            </CardActions>
            <Collapse in={expanded} timeout='auto' unmountOnExit>
              <CardContent>
                <Grid container justify='center' alignItems='center' direction='column'>
                  <Typography variant='subtitle2' color='textSecondary'>
                    Update Info
                  </Typography>
                  <FormControl className={classes.inputMobile}>
                    <TextField
                      style={{ margin: 10 }}
                      value={mobile}
                      label='Phone Number'
                      onChange={e => setMobile(e.target.value)}
                      variant='outlined'
                      id='formatted-text-mask-input'
                      InputProps={{
                        inputComponent: TextMaskCustom,
                      }}
                    />
                  </FormControl>
                  <div>
                    <Button onClick={handleCancel} className={classes.btnMobile}>
                      Cancel
                    </Button>
                    <Button onClick={handleSave} className={classes.btnMobile}>
                      Save
                    </Button>
                  </div>
                </Grid>
              </CardContent>
            </Collapse>
          </>
        )}
      </Card>
    </>
  );
};

export default ProfilePage;
